/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  tenants: [],
  error: '',
};

const getters = {
  tenants: state => state.tenants,
  getIndexById: id => state.tenants.findIndex(obj => obj.id === id),
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    Vue.http.get(`${process.env.BACKEND_API_URL}api/partners/product/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response.data);
      });
  },
  add({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/partners/${payload.companyId}/products/${payload.productId}`, { amount: payload.amount })
      .then(() => { })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, `${response.body.message}_for_pack`);
      });
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/partners/${payload.companyId}/products/${payload.productId}`)
      .then(() => { })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response.body.message);
      });
  },
  edit({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/partners/${payload.companyId}/products/${payload.productId}`, { amount: payload.amount })
      .then(() => { })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response.body.message);
      });
  },

};

const mutations = {
  [mTypes.DATA_FETCHED](state, tenants) {
    state.tenants = tenants.data;
  },
  [mTypes.DATA_STORED](state, response) {
    const previousIndex = getters.getIndexById(parseInt(response.data.tenant.id, 10));
    if (previousIndex >= 0) {
      state.tenants[previousIndex].permit_count = response.data.tenant.permit_count;
    } else {
      state.tenants.push(response.data.tenant);
    }
  },
  [mTypes.CLEAR_STATE](state) {
    state.tenants = [];
  },
  [mTypes.DATA_ERROR](state, response) {
    state.error = response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/products/tenants.js